<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :tables="pageData"
      :isExpansionPanelFooter="true"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="ma-10">
            <v-col cols="5" class="mr-16">
              <InputFormNew
                :heading="$t('ship.ship_ship-info')"
                v-model="localPageInfoData.line1"
                :detail="pageInfoDetail.line1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
                :isHideUnusedStorage="true"
              >
              </InputFormNew>
            </v-col>
            <v-col cols="5">
              <InputFormNew
                :heading="$t('ship.ship_ship-dest-info')"
                v-model="localPageInfoData.line2"
                :detail="pageInfoDetail.line2"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #postalCode="{ item }">
                  <!-- 郵便番号 -->
                  <PostalCodeArea
                    v-model="item.postalCode"
                    :countryId="item.country.value"
                    :height="inputFormStyle.inputItemHeight"
                    @click="onClickPostalCodeInvoiceInfo"
                  />
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
          <v-row no-gutters class="pa-0">
            <v-col cols="12" class="productTableCom">
              <ShipTable
                v-if="productInputData.length > 0"
                :headers="pageData[0].productHeaders"
                :propsItems="productInputData"
                :item-key="pageData[0].itemKey"
                @change="changeShipTable"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template #expansionPanelFooter0>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <div class="ma-2 btnStyle">
              <NormalButton
                :text="$t('ship.ship_ship')"
                textSize="16px"
                height="50px"
                width="100%"
                btnClass="ml-auto"
                :disabled="!isPossibleOperation"
                @click="register()"
              />
            </div>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <slot name="historyList" v-bind:item="historyListInfo" />
      </template>

      <template v-slot:[pageData[2].name]>
        <ClientInfo :recItems="recItems" />
      </template>
      <template v-slot:[pageData[3].name]>
        <OperationDetail :recItems="recItems" type="sale" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import {
  commonUtil,
  countryUtil,
  currencyUtil,
  countryCallingCodeUtil
} from '@/util'

import MultipleAreaBase from './MultipleAreaBase'

import headersShip from '@/views/sales/Ship/headers'

import headersHistory from '@/views/sales/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/CustomerInfo/CustomerInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'

import PostalCodeArea from '@/components/items/Designs/PostalCodeArea'

import ShipTable from '@/components/items/Tables/ShipTable'

import {
  NormalButton,
  InputFormNew,
  ProductTable,
  NormalNumberInput
} from '@/components/items'

export default {
  components: {
    MultipleAreaBase,
    InputFormNew,

    PostalCodeArea,
    // QuantityRackNumber,
    // NormalNumberInput,

    NormalButton,
    // ProductTable,

    ClientInfo,
    OperationDetail,
    ShipTable
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageInfoData: {},

    dialogReload: { default: 0 }
  },
  data: () => ({
    localPageInfoData: {},
    pageData: [
      {
        title: 'ship.ship_ship',
        name: 'shipInfo',
        productHeaders: [
          {
            text: 'product.product_product-number',
            value: 'product.productNumber',
            sortable: false,
            width: '135px',
            align: 'center'
          },
          {
            text: 'common.product_product-name',
            value: 'productName',
            sortable: false,
            width: '360px'
          },
          {
            text: 'common.product_capacity',
            value: 'product.capacity',
            sortable: false,
            width: '88px',
            align: 'center'
          },
          {
            text: 'sale.sale_number-of-sales',
            value: 'quantity',
            sortable: false,
            width: '88px',
            align: 'center'
          },
          {
            text: 'ship.ship_already-ship',
            value: 'done',
            sortable: false,
            width: '88px',
            align: 'center'
          },
          {
            text: 'ship.ship_not-ship',
            value: 'notYet',
            sortable: false,
            width: '88px',
            align: 'center'
          },
          {
            text: 'ship.ship_stock-quantity-rack',
            value: 'quantityAndStorageNo',
            sortable: false,
            width: '140px',
            align: 'center',
            rowspan: false
          },
          {
            text: 'ship.ship_ship-quantity',
            value: 'count',
            sortable: false,
            width: '120px',
            align: 'center',
            rowspan: false
          }
        ],
        itemKey: 'product.productNumber',
        items: null
      },
      {
        title: 'common.common_ship-history',
        name: 'shipHistory'
      },
      {
        title: 'payment.payment_customer-info',
        name: 'customerInfo'
      },
      {
        title: 'common.input_sale-details',
        name: 'salesDetail'
      }
    ],

    isPossibleOperation: false,

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },

    // pageData 0
    pageInfoDetail: {
      line1: [
        {
          name: 'storageName',
          text: 'ship.ship_ship-storage',
          required: true,
          component: 'SelectStorageName',
          cols: 4
        },
        {
          name: 'shipDate',
          text: 'ship.ship_ship-date',
          required: true,
          component: 'NormalDatePicker'
        },
        {
          name: 'trackingNumber',
          text: 'ship.ship_tracking-number'
        },
        {
          name: 'remarks',
          text: 'common.input_remarks',
          textPositionStart: true,
          component: 'Remarks'
        }
      ],
      line2: [
        {
          name: 'fullName',
          text: 'common.input_name'
        },
        {
          name: 'organizationName',
          text: 'user.user_company-name'
        },
        {
          name: 'phone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        },
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectCountry'
        },
        {
          name: 'postalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil((12 - 3) / 2)
        },
        {
          name: 'region',
          text: 'common.input_region',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectRegion'
        },
        {
          name: 'address1',
          text: 'common.input_address_1'
        },
        {
          name: 'address2',
          text: 'common.input_address_2'
        }
      ]
    },
    productData: [],
    productInputData: [],
    allRackNumberList: [],
    test: 0,

    clientInfoData: [],
    historyListInfo: {
      historyList: [],
      headers: [
        {
          text: 'ship.ship_ship-date',
          value: 'shipDate',
          width: '100px'
        },
        {
          text: 'ship.ship_ship-storage',
          value: 'storage.name',
          width: '90px'
        },
        {
          text: 'ship.ship_ship-user',
          value: 'userId',
          width: '90px'
        },
        {
          text: 'payment.payment_operation'
        }
      ],
      tableKey: headersShip.tableKey,
      productListHeaders: headersShip.productListHeaders
    }
  }),

  created() {},
  methods: {
    ...mapActions('Ship', ['getShipListFromApi', 'registerShip']),
    ...mapGetters('Ship', ['getShipListFromState']),
    ...mapActions('Sale', ['getRackNumberByProductFromApi']),
    ...mapGetters('Sale', ['getRackNumberByPaymentFromState']),
    ...mapActions('Common', ['setIsLoading']),

    getProductInputData(productMoveId, propertyName) {
      const rec =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return rec[propertyName]
    },
    changeShipTable(...args) {
      const [event, productMoveId, productId, rackNumber] = args

      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      target.rackNumberList = target.rackNumberList.map((ele) => {
        if (ele.rackNumber === rackNumber) {
          ele.count = event
        }
        return ele
      })
    },

    async init() {
      await this.getShipList()
      this.setProductInputData()
    },

    async getShipList() {
      const shipList = await this.getShipListFromApi({
        invalidShipDisplay: 0,
        saleControlNumber: this.recItems.transaction.controlNumber
      })
      const format = shipList.data
        .sort((a, b) => {
          const keyName = 'shipId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.panelIndex = Index + 1
          return ele
        })
      this.historyListInfo.historyList = format
    },
    async getRackNumber() {
      const productListForRackNumber = await this.getProductListForRackNumber()

      const allRackNumberList = productListForRackNumber.map((ele) => {
        return {
          productId: ele.productId,
          rackInfoList: ele.rackInfoList
        }
      })
      return allRackNumberList
    },
    async setProductInputData() {
      const allRackNumberList = await this.getRackNumber(false)

      this.productInputData = this.recItems.productMoves.map((ele) => {
        const doneLengt = this.getDone(ele)
        const notYetLengt = ele.quantity - doneLengt

        return {
          productMoveId: ele.productMoveId,
          productId: ele.product.productId,
          quantity: ele.quantity,
          product: ele.product,
          productLotNumber: '',
          productExpiredDate: '',
          done: doneLengt,
          notYet: notYetLengt,
          rackInfoList: [],
          rackNumberList: this.getRackNumberList(
            allRackNumberList,
            ele.product.productId,
            notYetLengt
          ),
          duplicateProductsNumber: ele.duplicateProductsNumber
        }
      })

      const ret = this.productInputData.filter((ele) => ele.notYet > 0)
      this.isPossibleOperation = ret.length > 0
    },

    getRackNumberList(allRackNumberList, productId, notYet) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        .map((ele) => {
          // ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
          return ele
        })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo, index) => {
          return { ...rackInfo, count: index === 0 ? notYet : 0 }
        })

      return rackInfoList
        ? rackInfoList
        : [
            {
              rackNumber: '',
              quantity: 0,
              count: 0
            }
          ]
    },

    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },

    getDone(saleProductMoves) {
      const shipList = this.getShipListFromState()
      return shipList.reduce((result, ship) => {
        const targetList = ship.productMoves.filter(
          (ele) => ele.product.productId === saleProductMoves.product.productId &&
            ele.duplicateProductsNumber ===
              saleProductMoves.duplicateProductsNumber
        )
        const targetAmount = targetList.reduce((result2, current2) => {
          return result2 + current2.quantity
        }, 0)
        return result + targetAmount
      }, 0)
    },

    onClickPostalCodeInvoiceInfo(...args) {
      const [address] = args

      const target = this.localPageInfoData.line2

      target.region = countryUtil.getRegionInfoByName(
        target.country.value,
        address.region
      )
      target.address1 = address.locality
      target.address2 = address.street
    },

    getNotYet(item) {
      return item.quantity - this.getDone(item)
    },

    async register() {
      const productListTmp = this.productInputData.filter((ele) => {
        const check = ele.rackNumberList.filter((rack) => rack.count > 0)
        return check.length > 0
      })

      if (!productListTmp.length) {
        alert(this.$t('sale.ship_no-input-ship-quantity'))
        return
      }

      this.setIsLoading(true)
      const params = {
        saleId: this.recItems.saleId,
        pageInfoData: this.localPageInfoData,
        productList: this.productInputData
      }
      const isConfirmed = confirm(this.$t('sale.ship_confirm-to-ship'))
      if (isConfirmed) {
        const isSucceed = await this.registerShip(params)
        if (isSucceed) {
          alert(this.$t('common.common_saved-alert'))
          // this.inputedValue.dialog = false
          this.$emit('complete')
        }
      }
      this.setIsLoading(false)
    },
    async getProductListForRackNumber() {
      // 対象販売履歴に紐づく全商品の棚番号一覧を取得
      const productIdList = [
        ...new Set(
          this.recItems.productMoves.map((ele) => ele.product.productId)
        )
      ]

      if (this.localPageInfoData.line1.storageName.value) {
        await this.getRackNumberByProductFromApi({
          storageId: this.localPageInfoData.line1.storageName.value,
          productIdList: productIdList
        })
      }

      const productListForRackNumber = this.getRackNumberByPaymentFromState()
      return productListForRackNumber
    },

    setInputData() {
      this.localPageInfoData = {
        line1: {
          storageName: { value: '', label: '' },
          shipDate: commonUtil.getToday(),
          trackingNumber: '',
          remarks: {
            data: '',
            title: '',
            text: ''
          }
        },
        line2: {
          fullName: this.recItems.recipientName,
          organizationName: this.recItems.recipientOrganizationName,
          phone: {
            countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
              this.recItems.recipientPhoneNumberCountryId
            ),
            phoneNumber: this.recItems.recipientPhoneNumber
          },
          country: countryUtil.getCountryIdInfo(
            this.recItems.recipientAddressCountryId
          ),
          postalCode: this.recItems.recipientPostalCode,
          region: countryUtil.getRegionInfo(
            this.recItems.recipientAddressCountryId,
            this.recItems.recipientRegionId
          ),
          address1: this.recItems.recipientAddress1,
          address2: this.recItems.recipientAddress2
        }
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      handler(newVal, oldVal) {
        this.setInputData()
      }
    },
    'inputedValue.dialog': async function (val) {
      if (val) {
        await this.init()
      }
    },
    'localPageInfoData.line1.storageName': {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.value) {
          await this.init()
        }
      }
    },
    dialogReload: async function (val) {
      if (val) await this.init()
    }
  }
}
</script>
<style lang="scss" scoped>
.btnStyle {
  width: 130px;
}
.normalNumberInput {
  width: 180px;
}
</style>
